import { setFilters_actionType } from "../constants";

export const setFilters = (filters) => {
  return {
    type: setFilters_actionType,
    payload: filters,
  };
};
